import {ISimplePresentation, ISimplePresentationRunnerController} from "../SimplePresentationRunner";
import {Game} from "../Game";
import {gsap} from "gsap";
import {IMonster} from "../server/IData";
import {MonsterSymbol} from "../reels/MonsterSymbol";
import {Sound} from "../sound/Sound";

export class C4Runner implements ISimplePresentation {

    public shouldRun(): boolean {
        return Game.model.gameData.monsters[3].path && Game.model.gameData.monsters[3].path.length > 1 && !Game.model.gameData.suspendedAction;
    }

    public start(controller: ISimplePresentationRunnerController): void {
        const tl: gsap.core.Timeline = gsap.timeline({
                onComplete: () => {
                    controller.finish();
                }
            }),
            monster: IMonster = Game.model.gameData.monsters[3];

        tl.add(() => {
            controller.setSkipCallback(() => {
                this.onSkip(tl);
            });
        });

        const monsterSymbol: MonsterSymbol = Game.reelsView.reelModels[monster.path[0].x].getMonsterSymbolAt(monster.symbol);
        monsterSymbol.setMonsterWalkIdx(3);

        tl.to(this, {
            duration: 0.1
        });

        tl.add([
            Game.collectAreaHighlightView.showHighlightEdges(monsterSymbol.getDistinctMPath(monster.path), monsterSymbol.name),
            Game.handleSpecialsInRespectivePathHighlight(monster.path, monsterSymbol.name)
        ]);
        Game.soundPlayer.playSound(Sound.TANK_START, 1);
        tl.add(monsterSymbol.walk(monster));
        tl.add(Game.collectAreaHighlightView.hideHighlightEdges(monsterSymbol.name));
    }

    private onSkip(tl: gsap.core.Timeline): void {
        const monster: IMonster = Game.model.gameData.monsters[3],
            monsterSymbol: MonsterSymbol = Game.reelsView.reelModels[monster.path[0].x].getMonsterSymbolAt(monster.symbol);

        monsterSymbol.isAborted = true;
        tl.totalProgress(1);
    }
}